import { render, staticRenderFns } from "./HowMuchItem.vue?vue&type=template&id=21a7ed2f&scoped=true"
import script from "./HowMuchItem.vue?vue&type=script&setup=true&lang=js"
export * from "./HowMuchItem.vue?vue&type=script&setup=true&lang=js"
import style0 from "./HowMuchItem.vue?vue&type=style&index=0&id=21a7ed2f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a7ed2f",
  null
  
)

export default component.exports